import {
	AddNewWorkspaceConnectionsViewProps,
	WorkspaceConnectedItemTypeConfiguration,
} from "src/components/views/workspaces/workspaceConnections/connectionTypes/WorkspaceConnectedItemTypeConfiguration.ts";
import i18n from "i18next";
import { faFolder } from "@fortawesome/pro-regular-svg-icons";
import { ConnectCatalogPartsToWorkspaceDataGrid } from "src/components/views/workspaces/workspaceConnections/connectionTypes/catalogPart/ConnectCatalogPartsToWorkspaceDataGrid.tsx";
import { CatalogPartsView } from "src/components/views/erp/parts/catalogPart/CatalogPartsView.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const workspaceCatalogPartConnectionsConfiguration: WorkspaceConnectedItemTypeConfiguration = {
	typeLabel: i18n.t("catalog_part"),
	icon: faFolder,
	isEnabled: () => true,
	addNewConnectionsView: (props: AddNewWorkspaceConnectionsViewProps) => {
		return <ConnectCatalogPartsToWorkspaceDataGrid {...props} />;
	},
	openItemDialog: ({ itemId, openDialog }) => {
		openDialog({
			title: i18n.t("catalog_part"),
			size: "fullscreen",
			agentContext: {
				key: defineAgentUiContextKey("workspaces.catalogPart.dialog"),
				title: i18n.t("catalog_part"),
				data: {
					catalogPartId: itemId,
				},
			},
			content: <CatalogPartsView catalogPartId={itemId} />,
		});
	},
};
